import isTestEnvironment from './isTestEnvironment';

const mockValueForTestEnvironment = <T>(productionValue: T, testValue: T): T =>
  isTestEnvironment() ? testValue : productionValue;

export default mockValueForTestEnvironment;
